import { PdfData } from "./types";

const HealthEventData: PdfData = {
  title: "Health event",
  description: {
    label: "Please report here health events related to the child",
    i18nKey: "Please report here health events relathed to the child",
  },
  fields: [
    {
      name: "eventDate",
      label: "Event date",
    },
    {
      name: "eventTime",
      label: "Event time",
    },
    {
      name: "eventMoment",
      label: "Event moment",
    },
    {
      name: "eventLocation",
      label: "Event location",
    },
    {
      name: "eventLocation",
      label: "Event location",
    },
    {
      name: "ageOfChild",
      label: "Age of the child involved in the incident",
    },
    {
      name: "eventType",
      label: "Event Type",
    },
    {
      name: "eventDescription",
      label: "Event Description (factual & taken care of elements)",
    },
    {
      name: "emsContacted",
      label: "EMS contacted",
    },
    {
      name: "hospitalization",
      label: "Hospitalization (including emergency room)",
    },
    {
      name: "aftercare",
      label: "Aftercare",
    },
    {
      name: "childAbsence",
      label: "Child absence",
    },
    {
      name: "securityLevel",
      label: "Severity level",
    },
    {
      name: "parentsBeenInformed",
      label: "Have the parents been informed?",
    },
    {
      name: "insuranceBeNotified",
      label: "Will insurance claim be filed?",
    },
    {
      name: "insuranceBeenNotified",
      label: "Has the insurance claim been filed?",
    },
    {
      name: "localAuthorityBeNotified",
      label: "Should the local authority be notified?",
    },
    {
      name: "localAuthorityBeenNotified",
      label: "Has the local authority been notified?",
    },
    {
      name: "supervisionRateRespected",
      label:
        "Was the supervision rate respected at the time of the accident in the reception area concerned?",
    },
    {
      name: "usualTeam",
      label: "Usual team in the reception area ?",
    },
    {
      name: "professionalNames",
      label:
        "Name of all professionals present in the unit where the event took place",
    },
    {
      name: "riskRelatedEvent",
      label: "Risks related to the Health incident",
    },
  ],
};

export default HealthEventData;
